/**
 * Safely extract a human-readable string from any Axios error.
 *
 * FastAPI can return detail as:
 *   - string  → "Email already registered"
 *   - array   → [{type, loc, msg, input, url}, ...]  (Pydantic 422)
 *   - object  → {code, message}  (fail-closed errors with a machine-readable code)
 */
export function apiError(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    // Pydantic v2 validation errors — join all messages
    return detail
      .map((d) => {
        const field = Array.isArray(d.loc) ? d.loc.filter((l) => l !== "body").join(" → ") : "";
        return field ? `${field}: ${d.msg}` : d.msg;
      })
      .join("; ");
  }
  if (typeof detail.message === "string" && detail.message) return detail.message;
  return fallback;
}
